export default {
  addUserInterest (context, payload) {
    return new Promise((resolve, reject) => {
      context.commit("addUserInterest", payload)
      resolve()
    })
  }
}
